export const mapDirectory = (values) => {
  const mappedDirectory = values.map((item) => ({
    id: item.directory_id,
    Nombre: item.name,
    Especialidad: item.specialty
  }));

  return mappedDirectory;
};
